import React, { useCallback, useEffect, useState, Children } from 'react';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/13ZNrC12YdqbTTebs5W6Np/Teach_for_the_Philippines_-_KATIG_Teacher_Training.jpg',
  alt: 'Teachers in a training session in the Philippines',
  caption: 'KATIG Teacher Training — Teach for the Philippines'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1H6auDPwh9zzfUiYa5zatp/Teach_for_the_Philippines_-_Tara_Kaya_Program.png',
  alt: 'Children learning through the Tara Kaya literacy program',
  caption: 'Tara Kaya Literacy Program'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/svuqCvjzYKpdsqKhxyHAry/DSCN3897.jpg',
  alt: 'Children smiling in a Southeast Asian community',
  caption: 'Community engagement across Southeast Asia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pFKH3vwEguyebNTbFmxX1T/P1140460.jpg',
  alt: 'Students learning together',
  caption: 'Building futures through education'
}];
export function EducationGallery() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const nextSlide = useCallback(() => {
    setActiveIndex(prev => (prev + 1) % galleryImages.length);
  }, []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  return <div className="relative w-full overflow-hidden bg-brand-charcoal" style={{
    aspectRatio: '4 / 5'
  }} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-56">
      {/* Images with crossfade */}
      {galleryImages.map((image, i) => <div key={i} className="absolute inset-0 transition-opacity duration-1000 ease-in-out" style={{
      opacity: i === activeIndex ? 1 : 0
    }} data-id="element-57">
          <img src={image.src} alt={image.alt} className="w-full h-full object-cover" data-id="element-58" />
        </div>)}

      {/* Bottom gradient overlay for caption + dots */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" data-id="element-59" />

      {/* Caption */}
      <div className="absolute bottom-12 left-0 right-0 px-6" data-id="element-60">
        <p className="text-white/80 text-sm font-medium tracking-wide transition-opacity duration-500" data-id="element-61">
          {galleryImages[activeIndex].caption}
        </p>
      </div>

      {/* Dot indicators */}
      <div className="absolute bottom-5 left-6 flex items-center gap-2" data-id="element-62">
        {galleryImages.map((_, i) => <button key={i} onClick={() => setActiveIndex(i)} className="relative h-1.5 rounded-full transition-all duration-500 focus:outline-none" style={{
        width: i === activeIndex ? '24px' : '8px',
        backgroundColor: i === activeIndex ? '#fff' : 'rgba(255,255,255,0.4)'
      }} aria-label={`Go to slide ${i + 1}`} data-id="element-63" />)}
      </div>

      {/* Progress bar */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-white/10" data-id="element-64">
        <div className="h-full bg-white/60 transition-all duration-300 ease-out" style={{
        width: `${(activeIndex + 1) / galleryImages.length * 100}%`
      }} data-id="element-65" />
      </div>
    </div>;
}